<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm > 
        <div v-if="needInit">{{initData()}}</div>   
        <v-layout row wrap>
            <v-flex xs6> <v-card outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <a-area v-bind:ltype="1"></a-area>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <a-area v-bind:ltype="2"></a-area>
            </v-card>  </v-flex>
            <v-flex xs12>                
                <v-layout row wrap>
                    <v-flex xs4>
                        <v-card>
                            <v-card-title class="layout justify-center">Area color:</v-card-title>
                            <v-card-text class="layout justify-center">
                                <v-color-picker
                                    v-model="myColor"     
                                ></v-color-picker>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs4> 
                        <v-card>
                            <v-card-title class="layout justify-center">Area image:</v-card-title>
                            <v-card-text class="layout justify-center">
                                <v-img
                                    v-if="imageURL" 
                                    :src="imageURL"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                    max-width="300"
                                    max-height="300" > </v-img>
                                <v-btn raised class="primary" @click="onPickFile">Upload image</v-btn>
                                <input type="file"
                                    accept="image/*" 
                                    ref="fileInput"
                                    style="display:none"
                                    @change="onFilePicked"
                                    >
                            </v-card-text>                        
                        </v-card>
                    </v-flex>                       
                </v-layout>
                
                 
            </v-flex>
            <v-flex xs12>
                <v-card outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                        <v-flex xs4>
                            <p>Category:
                                <v-menu v-if="categoryList.length > 0" transition="slide-y-transition" bottom right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn large class="my-3" color="primary" v-on="on">
                                            {{ categoryList[categoryIndex].name}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in categoryList"
                                            :key="index"
                                            @click="categoryIndex = index; categoryID = item.id;"
                                        >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>  
                                </v-menu>
                            </p>
                        </v-flex>
                            <v-flex xs6>
                                <v-card outlined>
                                    <v-btn @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import AArea from '../../../elements/AArea.vue'
import LanguageList from '../../../elements/LanguageList.vue'
import {mapGetters} from 'vuex'
import axios from '../../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             contentUni: null,
             categories: [],
             imageURL: '',
             image: null,
             myColor: '#8E00FF',
             categoryIndex : 0,
             categoryID : 0,
             categoryList: [],
             needInit : true,
             myID : 0,
             myOrder : 0
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContentUni',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig'                        
                    ])
    ,
    components: {
        AArea,
        LanguageList
    },
    methods : {
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked(event) {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf('.') <=0 ) {
                return alert('Please upload a valid file.')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () =>  {
                    this.imageURL = fileReader.result
                }
            )
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        },
        prepareDataforSave() {
            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            this.$store.commit('setFeedback', null)
            // prepare data for json
            const data = this.getAllContentUni

            this.contentUni = {
                area_id : this.myID,
                category_id: this.categoryID,
                color: this.myColor,
                icon: this.imageURL,
                area_order: this.myOrder,
                content_list: []
            }
            
            for(var key in data) {
                this.contentUni.content_list.push( {
                    lang_id : key.replace('l',''),
                    content :  data[key]
                })
            }

            // axios
            axios.post('/create-edit-area-all-lang', this.contentUni, this.$store.getters.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        
        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'areas', params: {id: this.categoryID}})   
        },
        initData() {
            this.needInit = false
            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)
           
            this.myID = this.$route.params.id

            if (this.myID == '0') {
                this.$store.commit('prepareUni','default')
                this.categoryID = JSON.parse(localStorage.getItem('position')).activeCategory.id
            } else {
            // load existing data
                axios.get('/get-area-in-all-lang/' + this.myID, this.$store.getters.getAxiosConfig )
                .then(res => {
                    const data = {                        
                        cType: 'default',
                        content_list : res.data.list
                    }

                    this.$store.dispatch('setFullContentUni', data)
                    this.categoryID = res.data.area_category_id
                    this.myColor = res.data.area_color
                    this.imageURL = res.data.area_icon                    
                    this.myOrder = res.data.area_order
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            } 

            axios.get('/get-categories3', this.$store.getters.getAxiosConfig )
            .then(res => {
                this.categoryIndex = 0
                this.categoryList = []
                for(let i = 0; i < res.data.list.length; i++) {
                    this.categoryList.push( {
                        id: res.data.list[i].category_id,
                        name: res.data.list[i].title
                    })
                    // set index in list
                    if (res.data.list[i].category_id == this.categoryID) this.categoryIndex = i
                 }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })

        }
    },
    mounted() {        
        this.needInit = true
    } 
     
}
</script>
